import {Component} from '@angular/core';

@Component({
  selector: 'app-ssr-demo',
  templateUrl: './ssr-demo.component.html',
  styleUrls: ['./ssr-demo.component.scss'],
  standalone: false,
})
export class SsrDemoComponent {}
